// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import directives from './directives'
import filters from './filters'
import ElementUI from 'element-ui'
import './assets/style/theme.scss'
import store from './store'
import { mapState, mapMutations } from 'vuex'
import axios from 'axios'
import VueClipboard from 'vue-clipboard2'
import VueAMap from 'vue-amap'
import jsPlumb from 'jsplumb'
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import VueQriously from 'vue-qriously'

import 'vant/lib/index.css'
import VANT from 'vant'
Vue.use(VANT)
Vue.use(VueQriously)
Vue.use(VueAMap)
// window._AMapSecurityConfig = {
//   securityJsCode: '92d31683fa7c37ff2602278fc027df22'
// }
VueAMap.initAMapApiLoader({
  key: '294fe5cff0c80fc4a346cd0ec69c2c96',
  plugin: ['AMap.Polyline', 'AMap.Driving', 'AMap.Autocomplete', 'AMap.PlaceSearch','AMap.Marker', 'AMap.Geolocation',
    'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor','AMap.Geocoder'],
  // 默认高德 sdk 版本为 1.4.4
  // v: '1.4.4'
})
Vue.use(VueClipboard)
Vue.use(VideoPlayer)
Vue.prototype.$http = axios
Vue.prototype.$jsPlumb = jsPlumb.jsPlumb
Vue.config.productionTip = false
Vue.use(directives)
Vue.use(filters)
Vue.use(ElementUI, {
  size: 'small'
})
// ip地址
/* Vue.prototype.$ipAddress = ''
const instance = axios.create({
  baseURL: 'https://api.ipify.org' // 设置基本的 API URL
  // 其他配置选项
})
// 将 Axios 实例添加到 Vue 实例的原型属性中
// Vue.prototype.$httpIp = instance

instance.get('?format=json').then((res) => {
  const ip = JSON.parse(JSON.stringify(res.data)).ip
  Vue.prototype.$ipAddress = ip
}).catch(function (err) {
  console.error('Failed to get IP address:', err)
}) */

// 角色按钮权限判断
Vue.mixin({
  methods: {
    hasPermission (permission) {
      // 登录用户权限
      var permissions = JSON.parse(this.$store.state.sysUserInfo).permissionCodes
      if (permissions.includes(permission)) {
        return true
      }
      return false
    }
  }
})
// 设置超时时间
axios.defaults.timeout = 100000000000000000
// 请求拦截器 在请求头中加token
axios.interceptors.request.use(
  config => {
    // 请求方法名称
    const method = config.url
    if (method.includes('api/sysUser/sysUserLogin')) {
      console.log(method)
      return config
    }

    // 将获取到的token设置给header中的token
    if (localStorage.getItem('token')) {
      // 检查token是否过期
      if (isTokenExpired()) {
        ElementUI.MessageBox.alert('登录已过期，请重新登录！', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        }).then(() => {
          // 用户点击了确定按钮后的回调函数
        }).catch(() => {
          // 用户点击了取消按钮后的回调函数
        })
        // 移除过期令牌
        localStorage.removeItem('token')
        localStorage.removeItem('expirationDate')
        // Token 已过期，执行相应操作（如重新登录或更新 Token）
        router.push('/login') // 假设登录界面的路由路径为 '/login'
        return Promise.reject(new Error('Token expired'))
      }
      config.headers.token = localStorage.getItem('token')
      // 把ip地址放到头部
      // if (Vue.prototype.$ipAddress === '') {
      //   instance.get('?format=json').then((res) => {
      //     const ip = JSON.parse(JSON.stringify(res.data)).ip
      //     Vue.prototype.$ipAddress = ip
      //   }).catch(function (err) {
      //     console.error('Failed to get IP address:', err)
      //   })
      // }
      // config.headers.ipAddress = Vue.prototype.$ipAddress
    }
    return config
  },
  error => {
    // alert('服务器正在部署中，请稍后再访问！谢谢')
    return Promise.reject(error)
  }
)
// 检查 Token 是否过期
function isTokenExpired () {
  const expirationDate = localStorage.getItem('expirationDate')
  return new Date().getTime() > expirationDate
}

// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    if (response.data.code === '50000') {
      ElementUI.MessageBox.alert('登录已过期，请重新登录', '提示', {
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        // 用户点击了确定按钮后的回调函数
      }).catch(() => {
        // 用户点击了取消按钮后的回调函数
      })
      localStorage.removeItem('token')
      localStorage.removeItem('expirationDate')
      router.push('/login') // token认证失败跳转登录界面
    }
    return response
  },
  (error) => {
    // 订单导出自行解析 Blob 错误，避免重复弹窗及 [object Blob]。
    if (error.config && error.config.skipGlobalErrorMessage) return Promise.reject(error)
    /* if (error.code === 'ECONNABORTED') {
      // 请求超时处理
      ElementUI.MessageBox.alert('请求超时！', '提示', {
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        // 用户点击了确定按钮后的回调函数
      }).catch(() => {
        // 用户点击了取消按钮后的回调函数
      })
    } else */ if (error.response.status === 504 | error.response.status === 502) {
      ElementUI.MessageBox.alert('您好，系统正在升级中，请稍后再访问！', '提示', {
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        // 用户点击了确定按钮后的回调函数
      }).catch(() => {
        // 用户点击了取消按钮后的回调函数
      })
    } else if (error.response.status === 500) {
      // 后端捕获到异常
      ElementUI.MessageBox.alert(error.response.data, '提示', {
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        // 用户点击了确定按钮后的回调函数
      }).catch(() => {
        // 用户点击了取消按钮后的回调函数
      })
    }

    return Promise.reject(error)
  }
)
// 当按钮被点击时，首先会检查按钮是否已禁用。如果按钮未禁用，则禁用按钮，并在一段时间后恢复按钮的可点击状
Vue.directive('disableWithDelay', {
  bind (el, binding) {
    let isDisabled = false

    el.addEventListener('click', () => {
      if (!isDisabled) {
        isDisabled = true
        el.disabled = true

        setTimeout(() => {
          isDisabled = false
          el.disabled = false
        }, binding.value)
      }
    })
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  data: {
    loading: false
  },
  router,
  store,
  components: { App },
  template: '<App/>',
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    ...mapMutations(['switchCollapseMenu']),
    // 初始化本地配置
    initLocalConfig () {
      const menuStatus = window.localStorage.getItem('MENU_STATUS')
      if (menuStatus != null) {
        this.switchCollapseMenu(menuStatus === 'true')
      }
    }
  },
  mounted () {
    this.initLocalConfig()
  }
})



// WEBPACK FOOTER //
// ./src/main.js